<template>
  <PullRefresh v-model="isLoading" success-text="刷新成功" @refresh="onRefresh">
    <div
      :class="`${$style.templatePage} ${hiddenTitle ? $style.hiddenTitle : ''}`"
    >
      <header>
        <div @click="closePage">
          <i class="iconfont yw-xiangzuo"></i>
        </div>
        <span>{{ pageTitle }}</span>
      </header>
      <div v-if="isWeChat" :class="$style.dialogMask" @click="isWeChat = false">
        <img
          :src="`${cdnLink}/box_subscribe/wxGuide.jpg`"
          :class="$style.wxGuide"
          loading="lazy"
        />
      </div>
      <div :class="$style.templateContent">
        <img :class="$style.image" :src="actPic" />
        <img
          v-if="showButton == 1"
          :class="`${$style.btn} copyFissionDeviceCodeCdk`"
          :src="btPic"
          @click="onClick"
        />
      </div>
    </div>
  </PullRefresh>
</template>

<script>
import { inithandler } from "@/bridge/jsBridge";
import {
  onGoBack,
  setPageTitle,
  toLogin,
  getUserInfo,
  signInEventTrack,
  jumpToNative,
} from "@/bridge/AppJsBridge";
import { PullRefresh } from "vant";
import { checkIsWxBrowser, pageLoseTips, getCookie, decryptDes, encryptDes } from "@/libs/utils";
import { getWxTemplateApi, sendDeviceCodeApi } from "@/apis/wxActivity";
import { burnPoint } from "@/apis/heziShare";
import { queue } from "@/libs/queue.request";
import { CDN_URL_1 } from "@/config";
import { v1 as uuidv1} from "uuid";
import Clipboard from "clipboard";


const pointObj = {
  1: ["active_self_page", "active_self_button"],
  2: ["invite_user_share_page", "invite_user_share_page_download"],
};

export default {
  name: "",
  components: { PullRefresh },
  data() {
    return {
      cdnLink: CDN_URL_1,
      cookie: "",
      hiddenTitle: true,
      isLoading: false,
      actId: "",
      pageTitle: "活动",
      actPic: "",
      btPic: "",
      hasToken: false,
      reqQueue: queue(),
      pageData: {},
      showButton: false,
      pageType: 1, // 默认为类型1-通用活动 2-邀请分享活动
      isWeChat: false,
      decryptUid: '', //用户id
      decryptUsername: '', // 用户名
      deviceCode: '', // 设备号
    };
  },
  created() {
    // 页面初始化
    inithandler();

    // 获取设备信息
    this.reqQueue.create();
    this.initPageData();
    try {
      signInEventTrack((data) => {
        this.cookie = JSON.parse(data);
      });
    } catch (error) {
      console.log("🚀 ~ file: signInEventTrack", error);
    }
  },
  watch: {
    cookie(value, oldValue) {
      if (!oldValue && value && !getCookie()) {
        this.reqQueue.run(value);
      }
    },
  },
  activated() {},
  // mounted() {
  //   this.copy = new Clipboard(".copyFissionDeviceCodeCdk");
  // },
  methods: {
    // 判断是否需要隐藏标题拦
    checkHasPageTitle() {
      if (checkIsWxBrowser()) {
        this.hiddenTitle = true;
      }
    },

    // 获取cookie、缓存等携带的用户信息数据
    initPageData() {
      const { history } = this.$router;
      const { id, uid, userName } = history.current.query;
      if (!id) {
        pageLoseTips(this.$toast);
        return;
      }
      let idAndType = id.split('_');
      let typeStr = idAndType[1];
      let type = 1;
      this.actId = idAndType[0];
      if (typeStr && typeStr.split('=')[1]) {
        type = typeStr.split('=')[1];
        this.pageType = typeStr.split('=')[1];
      }else{
        pageLoseTips(this.$toast);
        return;
      }

      this.checkHasPageTitle();

      const pageCookie = getCookie();
      if (pageCookie) {
        for (const key in pageCookie) {
          if (
            Object.hasOwnProperty.call(pageCookie, key) &&
            pageCookie[key] === "null"
          ) {
            delete pageCookie[key];
          }
        }
        this.cookie = pageCookie;
      }
      // 通用活动
      if (type == 1) {
        // 获取token
        this.getAppToken();
      }
      // 裂变活动分享页面
      if (type == 2) {
        document.title = '你的好友邀请你并肩作战';
        // 解密
        try {
          this.decryptUid =  decryptDes('wxfisshk','wxfisshk',uid);
          this.decryptUsername =  decryptDes('wxfisshk','wxfisshk',userName);
        } catch (error) {
          console.log("分享页 error:", error)
        }
        // 生成设备号
        this.deviceCode = uuidv1();
        this.getTemplateInfo(this.actId);
      }
    },

    getAppToken() {
      if (getCookie("token")) {
        this.hasToken = true;
        localStorage.setItem("token", getCookie("token"));
        this.getTemplateInfo(this.actId);
      } else {
        getUserInfo((userInfo) => {
          let Info = JSON.parse(userInfo);
          if (Info.token) {
            this.hasToken = true;
            localStorage.setItem("token", Info.token);
            this.getTemplateInfo(this.actId);
          } else {
            toLogin("/loginKey/LoginByKeyPhoneActivity");
          }
        });
      }
    },

    // 上报设备标识
    async sendDeviceCode(){
      const params = {
        uniqueCode: this.deviceCode,
        uid: Number(this.decryptUid)
      }
      const encryptParams = encryptDes('wxfisshk','wxfisshk', params)
      let formData = new FormData();
      formData.append('data', encryptParams)
      try {
        await sendDeviceCodeApi(formData)
      } catch (error) {
        console.log("error:", error)
      }
    },

    getTemplateInfo(id) {
      getWxTemplateApi({ id })
        .then((res) => {
          const { actIcon, buttonIcon, actTitle, showButton, type } = res.data;
          this.actPic = actIcon;
          this.btPic = buttonIcon;
          this.pageTitle = actTitle;
          this.pageData = res.data;
          this.showButton = showButton;
          setPageTitle(actTitle);
          const { transformUserType, tagStrategyId } = this.getTheQuery()
          const extraParams = {}
          if (transformUserType) extraParams.scene_type = transformUserType
          if (tagStrategyId) extraParams.tag_strategy_id = tagStrategyId
          this.eventTrack({
            event: pointObj[type][0],
            event_field: JSON.stringify({
              actName: this.pageTitle,
              actId: this.actId,
              type,
              ...extraParams,
            }),
          });
        })
        .catch((error) => {
          /** */
        });
    },

    // 250411: 透传转游策略参数
    getTheQuery () {
      const data = {}
      const source = this.$route.query.id
      if (source && source.includes('=')) {  
        const querys = source.split('_')
        const [a, b, ...rest] = querys || []
        if (rest && rest.length) {
          rest.forEach(v => {
            if (!v.includes('=')) return
            const [key, value] = v.split('=')
            data[key] = value
          })
        }
      }
      return data
    },

    // 数据上报
    eventTrack(data) {
      // this.$toast(data.event);
      const params = {
        ...data,
      };
      if (!this.cookie && this.pageType == 1) {
        console.log("数据上报异常", data.event, "转为补充数据上报");
        this.reqQueue.add(burnPoint, params);
        return;
      }
      console.log("正常数据上报", data.event);
      burnPoint({
        ...this.cookie,
        ...params,
      }).catch((err) => console.log(err));
    },

    // 关闭页面
    closePage() {
      onGoBack();
    },

    // 下拉刷新
    async onRefresh() {
      // if (this.pageType == 1 && !this.hasToken) {
      //   toLogin("/loginKey/LoginByKeyPhoneActivity");
      //   return
      // }
      await this.initPageData();
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    onCopy(){
      // :data-clipboard-text="`inviteCode_${deviceCode}_${decryptUsername}`"
      let that = this;
      let clipboard = new Clipboard(".copyFissionDeviceCodeCdk", {
        text: function (trigger) {
          //返回字符串
          return `inviteCode_${that.deviceCode}_${that.decryptUsername}`;
        },
      });
      clipboard.on("success", (e) => {
        //复制成功
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        //复制失败
        clipboard.destroy();
      });
    },

    onClick() {
      const { type, jumpType, jumpValue } = this.pageData;
      if (type == 2) {
        if (checkIsWxBrowser()) {
          this.isWeChat = true;
          return;
        }
        this.sendDeviceCode();
        this.onCopy();
      }

      // 1-活动 2-游戏
      if (jumpType == 1 || jumpType == 2) {
        let routePath = [
          "", // 无意义 占位用
          "/main/NewGameActivity",
          "/main/game/GameDetailActivity",
        ];
        const data = {
          routePath: routePath[jumpType],
          extraParams: jumpValue,
        };
        if (jumpType == 2) {
          data.fromPageType = 23; // ACTIVITIES_DOWN = 23//活动详情直接下载
          const extra = this.getTheQuery()
          Object.keys(extra).forEach(k => {
            data[k] = extra[k]
          })
        }
        const dataStr = JSON.stringify(data);
        jumpToNative(dataStr);
      }
      // 外部链接
      if (jumpType == 3) {
        setTimeout(() => {
          window.open(jumpValue, "_blank");
        }, 500);
      }
      // 应用内链接
      if (jumpType == 4) {
        const data = { routePath: jumpValue };
        const dataStr = JSON.stringify(data);
        jumpToNative(dataStr);
      }

      if (this.actId) {
        let eventField = {
          actName: this.pageTitle,
          actId: this.actId,
          type,
        }
        if (type == 2) {
          eventField.code = this.deviceCode;
        }
        this.eventTrack({
          event: pointObj[type][1],
          event_field: JSON.stringify(eventField),
        });
      }
    },
  },
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
<style lang="scss" module>
.templatePage {
  width: 100%;
  height: 100%;
  max-width: 375px;
  margin: auto;
  padding-top: 50px;
  overflow: auto;
  &.hiddenTitle {
    padding-top: 0px;
    > header {
      display: none;
    }
  }
  > header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    max-width: 375px;
    margin: auto;
    z-index: 3;
    background: #ffffff;
    color: #000000;
    font-size: 19px;
    padding: 14px 5px 14px 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > div {
      font-weight: bold;
      position: absolute;
    }
    > span {
      font-size: 18px;
      font-weight: 700;
      margin: 0 auto;
    }
    :global {
      .iconfont {
        font-size: 22px;
        margin-right: 5px;
      }
    }
  }

  .dialogMask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 99;

    > img {
      width: 100%;
    }
  }
  .templateContent {
    width: 100%;
    height: auto;
    .image {
      width: 100%;
    }

    .btn {
      width: 100%;
      position: fixed;
      bottom: 0px;
      left: 0;
      right: 0;
      margin: 0 auto;
    }
  }
}
</style>
